import { render } from "./HeadSlider.vue?vue&type=template&id=2add329d"
import script from "./HeadSlider.vue?vue&type=script&lang=js"
export * from "./HeadSlider.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Admin\\Desktop\\Projects\\maytoni\\vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__